import { intercomTrackEvent } from './intercomService';

export const analyticsEvent = intercomTrackEvent;
